import Marquee from "react-fast-marquee";

export default function MarqueeRibbon() {
    return (
        <section
            data-testid="marquee-section"
            aria-hidden="true"
            className="relative py-6 lg:py-10 border-y border-black/10 overflow-hidden"
        >
            <Marquee speed={60} gradient={false}>
                <span className="marquee-text outline-text mx-8">
                    From seed
                </span>
                <span className="marquee-text mx-8 text-olive">/</span>
                <span className="marquee-text mx-8">to scale</span>
                <span className="marquee-text outline-text mx-8">/</span>
                <span className="marquee-text mx-8">Performance</span>
                <span className="marquee-text outline-text mx-8">·</span>
                <span className="marquee-text mx-8">Branding</span>
                <span className="marquee-text outline-text mx-8">·</span>
                <span className="marquee-text mx-8">Content</span>
                <span className="marquee-text outline-text mx-8">·</span>
            </Marquee>
        </section>
    );
}
